module.exports = __webpack_public_path__ + "img/img_17.b2388a04.png";